<!--测温看板-->
<template>
	<div class="usePowerUnitBody custom-scrollbar">
		<!-- 通用-单位信息 -->
		<unitInfo class="marginRight smallWindow"></unitInfo>
		<!-- 通用-月事件告警统计环比 -->
		<workStateNoWork class="smallWindow"></workStateNoWork>
		<deviceLine class="bigWindow marginTop"></deviceLine>
	</div>
</template>

<script>
	import unitInfo from '@/page/unitProfile/unitInfo.vue'
	import workStateNoWork from '@/page/unitProfile/workStateNoWork.vue'
	import deviceLine from '@/page/system/temperature/deviceLine.vue'
	export default {
		components: {
			unitInfo,
			workStateNoWork,
			deviceLine,
		},
		props: {},
		data() {
			return {}
		},
		created() {},
		mounted() {},
		destroyed() {},
		computed: {},
		watch: {},
		methods: {

		}
	}
</script>

<style scoped>
	.usePowerUnitBody {
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
		height: calc(100% - 20px);
		padding: 1%;
		/*overflow: auto;*/
	}
	
	.usePowerUnitBody::-webkit-scrollbar {
		display: none;
	}
	
	.smallWindow {
		width: calc(50% - 6px);
		height: 270px;
	}
	
	.marginRight {
		margin-right: 8px;
	}
	
	.marginTop {
		margin-top: 8px;
	}
	
	.bigWindow {
		width: 100%;
		height: 270px;
	}
</style>